import Panel from 'emerald-ui/lib/Panel';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Panel, componentName: 'Panel' }], 'Panel'),
  description: 'A Panel is a simple card-like container.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Panel },
      code: `<Panel>
  <Panel.Body>
    <h1>Panel</h1>
    <p>A simple panel</p>
  </Panel.Body>
</Panel>`,
    },
  ],
};
